import React, {FC} from 'react';
import apple from '../assets/images/apple.svg';

interface Props {
}

const AppleBtn: FC<Props> = () => {
  return (
    <a className='apple-btn' href="https://itunes.apple.com/US/app/id1610728765" target="_blank">
      <img src={apple} alt="apple"/>
      <div >
        <div>Download on the</div>
        <h4 className='mb-0'>App Store</h4>
      </div>
    </a>
  );
}

export default AppleBtn;